(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coal-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('coal-modal');
    if (!modal) return;
    const form = modal.querySelector('[data-coal-form]');
    const input = form.querySelector('[name="coal"]');
    const field = form.querySelector('[data-coal-field]');
    const error = form.querySelector('[data-coal-error]');
    let trigger = null;

    const radio = (value) => form.querySelector('[name="mode"][value="' + value + '"]');
    const choiceTitle = (value) => radio(value).closest('label').querySelector('.coal-modal__choice-title').textContent.trim();
    const syncField = () => {
      field.hidden = !radio('reload').checked;
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-coal-open]');
      if (!btn) return;
      trigger = btn;
      // "Elaboruję" always stores a COAL value, "Amunicja fabryczna" never does
      const reload = Boolean(btn.dataset.coalValue);
      radio('reload').checked = reload;
      radio('factory').checked = !reload;
      input.value = btn.dataset.coalValue || '';
      input.setAttribute('aria-invalid', 'false');
      error.hidden = true;
      syncField();
      modal.showModal();
    });

    form.addEventListener('change', (e) => {
      if (e.target.name !== 'mode') return;
      syncField();
      if (!field.hidden) input.focus();
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!trigger) return;
      // Liquid renders an empty properties hash as "[]" — normalise to a plain object or Shopify rejects the change
      let properties = {};
      try {
        const parsed = JSON.parse(trigger.dataset.coalProperties || '{}');
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) properties = parsed;
      } catch (err) {}
      if (radio('reload').checked) {
        // Accept both "57,4" and "57.4"; validate against the range from theme settings
        const raw = String(input.value).trim().replace(',', '.');
        const value = /^\d+(\.\d+)?$/.test(raw) ? parseFloat(raw) : NaN;
        const min = parseFloat(form.dataset.min);
        const max = parseFloat(form.dataset.max);
        if (isNaN(value) || value < min || value > max) {
          error.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.setAttribute('aria-invalid', 'false');
        properties['Elaboracja'] = choiceTitle('reload');
        // Stored with a decimal comma ("57,4 mm") — matches the spec and the PL/CZ/SK/DE markets
        properties['COAL (mm)'] = value.toFixed(2).replace(/\.?0+$/, '').replace('.', ',') + ' mm';
      } else {
        properties['Elaboracja'] = choiceTitle('factory');
        delete properties['COAL (mm)'];
      }
      const detail = {
        line: parseInt(trigger.dataset.coalLine, 10),
        quantity: parseInt(trigger.dataset.coalQty, 10),
        variantId: parseInt(trigger.dataset.coalVariant, 10),
        properties,
        trigger,
      };
      trigger = null;
      modal.close();
      document.dispatchEvent(new CustomEvent('coal:save', { detail }));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* Hover z nabojami (komputer): plik ładuje się dopiero przy pierwszym najechaniu myszą na kartę,
     żeby kolekcja nie pobierała drugiego kompletu zdjęć na starcie */
  const cardHoverMedia = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const loadCardHover = (hover) => {
    if (!hover || !hover.dataset.src || hover.dataset.loaded === hover.dataset.src) return;
    hover.dataset.loaded = hover.dataset.src;
    hover.classList.remove('is-ready');
    const ready = () => hover.classList.add('is-ready');
    hover.addEventListener('load', ready, { once: true });
    if (hover.dataset.srcset) hover.srcset = hover.dataset.srcset;
    hover.src = hover.dataset.src;
    if (hover.complete && hover.naturalWidth) ready();
  };
  document.addEventListener('pointerover', (e) => {
    if (!cardHoverMedia.matches || e.pointerType !== 'mouse') return;
    const card = e.target.closest('[data-product-card]');
    if (card) loadCardHover(card.querySelector('[data-card-hover]'));
  });

  /* Card swatches: pick the colour, swap the thumbnail, point "Do koszyka" at that variant */
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-card-swatch]');
    if (!swatch) return;
    e.preventDefault();
    const card = swatch.closest('[data-product-card]');
    if (!card) return;
    card.querySelectorAll('[data-card-swatch]').forEach((b) => {
      const on = b === swatch;
      b.classList.toggle('product-card__swatch--active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const img = card.querySelector('.product-card__image:not(.product-card__image--hover)');
    if (img && swatch.dataset.imgSrc && img.dataset.current !== swatch.dataset.imgSrc) {
      img.dataset.current = swatch.dataset.imgSrc;
      if (swatch.dataset.imgSrcset) img.srcset = swatch.dataset.imgSrcset;
      img.src = swatch.dataset.imgSrc;
      if (swatch.dataset.imgAlt) img.alt = swatch.dataset.imgAlt;
    }
    const hover = card.querySelector('[data-card-hover]');
    if (hover && swatch.dataset.hoverSrc) {
      hover.dataset.src = swatch.dataset.hoverSrc;
      hover.dataset.srcset = swatch.dataset.hoverSrcset || '';
      if (cardHoverMedia.matches) loadCardHover(hover);
    }
    const form = card.querySelector('[data-card-add]');
    if (form && swatch.dataset.variantId) {
      form.querySelector('input[name="id"]').value = swatch.dataset.variantId;
      const btn = form.querySelector('button');
      const label = form.querySelector('[data-card-add-label]');
      const available = swatch.dataset.available !== 'false';
      btn.disabled = !available;
      if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelUnavailable;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
